/**
 * @generated SignedSource<<8018ab3ac3bcc082695bf7da3be6d492>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClubNavigatorQuery$variables = {
  clubSlug: string;
};
export type ClubNavigatorQuery$data = {
  readonly session: {
    readonly currentClientProfile: {
      readonly member: {
        readonly club: {
          readonly appCustomization: {
            readonly conversionAnalytics: {
              readonly enabled: boolean;
              readonly ga4MeasurementId: string | null | undefined;
              readonly gtmContainerId: string | null | undefined;
              readonly metaPixelId: string | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly defaultLocale: string;
          readonly id: string;
          readonly logoImage: {
            readonly publicId: string;
          } | null | undefined;
          readonly name: string;
          readonly slug: string;
          readonly supportsPublic: boolean;
          readonly " $fragmentSpreads": FragmentRefs<"ClubCurrencyContextFragment">;
        };
        readonly departmentMemberProfiles?: ReadonlyArray<{
          readonly department?: {
            readonly slug: string;
          } | null | undefined;
          readonly ghinNumber?: number | null | undefined;
        } | null | undefined> | null | undefined;
        readonly email?: string | null | undefined;
        readonly firstName?: string | null | undefined;
        readonly id?: string;
        readonly lastName?: string | null | undefined;
        readonly memberGroups?: ReadonlyArray<{
          readonly id: string;
        } | null | undefined> | null | undefined;
        readonly membershipType?: {
          readonly id: string;
        } | null | undefined;
        readonly phoneNumber?: {
          readonly nationalNumber: string;
        } | null | undefined;
        readonly profileImage?: {
          readonly publicId: string;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly user: {
      readonly email: string | null | undefined;
      readonly id: string;
      readonly memberProfiles?: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly member: {
              readonly club: {
                readonly id: string;
                readonly logoImage: {
                  readonly publicId: string;
                } | null | undefined;
                readonly name: string;
                readonly slug: string;
              };
            } | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly metadata?: {
        readonly hasSeenNotificationNudgeModal: boolean | null | undefined;
      } | null | undefined;
      readonly preferredLocale?: string | null | undefined;
      readonly username: string | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"useRegisterDeviceForPushNotificationsAsyncFragment_memberUser">;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"ClubStackNavigatorFragment_session" | "useSyncAnalyticsTrackingPermission_session">;
  } | null | undefined;
  readonly unauthenticatedClub: {
    readonly conversionAnalytics: {
      readonly enabled: boolean;
      readonly ga4MeasurementId: string | null | undefined;
      readonly gtmContainerId: string | null | undefined;
      readonly metaPixelId: string | null | undefined;
    } | null | undefined;
    readonly defaultLocale: string;
    readonly id: string | null | undefined;
    readonly logoImage: {
      readonly publicId: string;
    } | null | undefined;
    readonly name: string;
    readonly slug: string;
    readonly supportsPublic: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"ClubCurrencyContextUnauthenticatedFragment">;
  } | null | undefined;
};
export type ClubNavigatorQuery = {
  response: ClubNavigatorQuery$data;
  variables: ClubNavigatorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "clubSlug"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowUnauthenticatedAnalyticsTracking",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requiresAnalyticsTrackingConsent",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "analyticsTrackingConsentedAt",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultCountryCode",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "preferredLocale",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasSeenNotificationNudgeModal",
  "storageKey": null
},
v11 = {
  "kind": "Literal",
  "name": "active",
  "value": true
},
v12 = [
  (v11/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v15 = [
  {
    "alias": "publicId",
    "args": null,
    "kind": "ScalarField",
    "name": "renderingKey",
    "storageKey": null
  }
],
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "logoImage",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "Club",
  "kind": "LinkedField",
  "name": "club",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/),
    (v16/*: any*/)
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nationalNumber",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "PhoneNumber",
  "kind": "LinkedField",
  "name": "phoneNumber",
  "plural": false,
  "selections": [
    (v20/*: any*/)
  ],
  "storageKey": null
},
v22 = [
  (v6/*: any*/)
],
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "MembershipType",
  "kind": "LinkedField",
  "name": "membershipType",
  "plural": false,
  "selections": (v22/*: any*/),
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "profileImage",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "MemberGroup",
  "kind": "LinkedField",
  "name": "memberGroups",
  "plural": true,
  "selections": (v22/*: any*/),
  "storageKey": null
},
v26 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "GOLF"
  }
],
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ghinNumber",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": (v26/*: any*/),
  "concreteType": null,
  "kind": "LinkedField",
  "name": "departmentMemberProfiles",
  "plural": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v27/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Department",
          "kind": "LinkedField",
          "name": "department",
          "plural": false,
          "selections": [
            (v14/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "GolfMemberProfile",
      "abstractKey": null
    }
  ],
  "storageKey": "departmentMemberProfiles(type:\"GOLF\")"
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "CustomerType",
  "kind": "LinkedField",
  "name": "membershipType",
  "plural": false,
  "selections": (v22/*: any*/),
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "supportsPublic",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultLocale",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "ConversionAnalytics",
  "kind": "LinkedField",
  "name": "conversionAnalytics",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gtmContainerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ga4MeasurementId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "metaPixelId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v33 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "clubSlug"
  }
],
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "UnauthenticatedImage",
  "kind": "LinkedField",
  "name": "logoImage",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLessonsEnabled",
  "storageKey": null
},
v36 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "patronAccess",
    "storageKey": null
  },
  (v6/*: any*/)
],
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "PublicLessonsPermissionSet",
  "kind": "LinkedField",
  "name": "publicLessonsPermissionSet",
  "plural": false,
  "selections": (v36/*: any*/),
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "PrivateLessonsPermissionSet",
  "kind": "LinkedField",
  "name": "privateLessonsPermissionSet",
  "plural": false,
  "selections": (v36/*: any*/),
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "supportsPrivate",
  "storageKey": null
},
v41 = [
  (v6/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isFacilityVisible",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isFacilityBookable",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "areOtherBookingsVisible",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "areOtherBookingsJoinable",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "canBookOnBusySlot",
    "storageKey": null
  }
],
v42 = {
  "kind": "Literal",
  "name": "saleAvailability",
  "value": "PUBLIC"
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v44 = [
  (v43/*: any*/)
],
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plural",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v47 = [
  (v14/*: any*/),
  (v6/*: any*/)
],
v48 = {
  "alias": null,
  "args": (v26/*: any*/),
  "concreteType": null,
  "kind": "LinkedField",
  "name": "departmentMemberProfiles",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v27/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Department",
          "kind": "LinkedField",
          "name": "department",
          "plural": false,
          "selections": (v47/*: any*/),
          "storageKey": null
        }
      ],
      "type": "GolfMemberProfile",
      "abstractKey": null
    },
    (v6/*: any*/)
  ],
  "storageKey": "departmentMemberProfiles(type:\"GOLF\")"
},
v49 = {
  "alias": null,
  "args": null,
  "concreteType": "PhoneNumber",
  "kind": "LinkedField",
  "name": "phoneNumber",
  "plural": false,
  "selections": [
    (v20/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v50 = {
  "kind": "InlineFragment",
  "selections": (v22/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v51 = [
  (v11/*: any*/),
  {
    "kind": "Literal",
    "name": "hidden",
    "value": false
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClubNavigatorQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ClubStackNavigatorFragment_session"
          },
          {
            "kind": "InlineDataFragmentSpread",
            "name": "useSyncAnalyticsTrackingPermission_session",
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "MemberUser",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "currentClientProfile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "member",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Club",
                        "kind": "LinkedField",
                        "name": "club",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "args": null,
            "argumentDefinitions": []
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useRegisterDeviceForPushNotificationsAsyncFragment_memberUser"
              },
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v12/*: any*/),
                    "concreteType": "MemberProfileConnection",
                    "kind": "LinkedField",
                    "name": "memberProfiles",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberProfileEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberProfile",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "member",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "memberProfiles(active:true)"
                  }
                ],
                "type": "MemberUser",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v7/*: any*/),
                      (v21/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v28/*: any*/)
                    ],
                    "type": "Member",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v28/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v21/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v24/*: any*/),
                      (v29/*: any*/)
                    ],
                    "type": "Customer",
                    "abstractKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AppCustomization",
                        "kind": "LinkedField",
                        "name": "appCustomization",
                        "plural": false,
                        "selections": [
                          (v32/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "ClubCurrencyContextFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v33/*: any*/),
        "concreteType": "UnauthenticatedClub",
        "kind": "LinkedField",
        "name": "unauthenticatedClub",
        "plural": false,
        "selections": [
          (v31/*: any*/),
          (v6/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v30/*: any*/),
          (v32/*: any*/),
          (v34/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ClubCurrencyContextUnauthenticatedFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClubNavigatorQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "staffAccessAvailable",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientClass",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DepartmentConnection",
                        "kind": "LinkedField",
                        "name": "departments",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DepartmentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Department",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "anyFacilityLessonsEnabled",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FacilityConnection",
                                    "kind": "LinkedField",
                                    "name": "facilities",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FacilityEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Facility",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v35/*: any*/),
                                              (v37/*: any*/),
                                              (v38/*: any*/),
                                              (v6/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "anyFacilityEventsEnabled",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityConnection",
                        "kind": "LinkedField",
                        "name": "facilities",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FacilityEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Facility",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v14/*: any*/),
                                  (v35/*: any*/),
                                  (v37/*: any*/),
                                  (v38/*: any*/),
                                  (v6/*: any*/),
                                  (v39/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Club",
                                    "kind": "LinkedField",
                                    "name": "club",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v40/*: any*/),
                                      (v30/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PublicBookingPermissionSet",
                                    "kind": "LinkedField",
                                    "name": "publicBookingPermissionSet",
                                    "plural": false,
                                    "selections": (v41/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PrivateBookingPermissionSet",
                                    "kind": "LinkedField",
                                    "name": "privateBookingPermissionSet",
                                    "plural": false,
                                    "selections": (v41/*: any*/),
                                    "storageKey": null
                                  },
                                  (v13/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Department",
                                    "kind": "LinkedField",
                                    "name": "department",
                                    "plural": false,
                                    "selections": [
                                      (v39/*: any*/),
                                      (v6/*: any*/),
                                      (v14/*: any*/),
                                      (v13/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "standardPackages",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "packageType",
                            "value": "STANDARD"
                          },
                          (v42/*: any*/)
                        ],
                        "concreteType": "PackageConnection",
                        "kind": "LinkedField",
                        "name": "packages",
                        "plural": false,
                        "selections": (v44/*: any*/),
                        "storageKey": "packages(packageType:\"STANDARD\",saleAvailability:\"PUBLIC\")"
                      },
                      {
                        "alias": "memberships",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "packageType",
                            "value": "MEMBERSHIP"
                          },
                          (v42/*: any*/)
                        ],
                        "concreteType": "PackageConnection",
                        "kind": "LinkedField",
                        "name": "packages",
                        "plural": false,
                        "selections": (v44/*: any*/),
                        "storageKey": "packages(packageType:\"MEMBERSHIP\",saleAvailability:\"PUBLIC\")"
                      },
                      (v30/*: any*/),
                      (v40/*: any*/),
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ClubCopyOverrides",
                        "kind": "LinkedField",
                        "name": "copyOverrides",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NounOverride",
                            "kind": "LinkedField",
                            "name": "event",
                            "plural": false,
                            "selections": [
                              (v45/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NounOverride",
                            "kind": "LinkedField",
                            "name": "lesson",
                            "plural": false,
                            "selections": [
                              (v45/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "singular",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AppCustomization",
                        "kind": "LinkedField",
                        "name": "appCustomization",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ExternalLink",
                            "kind": "LinkedField",
                            "name": "externalLinks",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "displayName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "url",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v6/*: any*/),
                          (v32/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "calendarStartDay",
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      (v13/*: any*/),
                      (v31/*: any*/),
                      (v16/*: any*/),
                      (v46/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/),
                      (v48/*: any*/),
                      (v7/*: any*/),
                      (v49/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v24/*: any*/),
                      (v29/*: any*/)
                    ],
                    "type": "Customer",
                    "abstractKey": null
                  },
                  (v50/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v49/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v48/*: any*/)
                    ],
                    "type": "Member",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v50/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "onboardedAt",
                    "storageKey": null
                  }
                ],
                "type": "MemberProfile",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "activeMemberProfiles",
                    "args": (v51/*: any*/),
                    "concreteType": "MemberProfileConnection",
                    "kind": "LinkedField",
                    "name": "memberProfiles",
                    "plural": false,
                    "selections": [
                      (v43/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberProfileEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberProfile",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hidden",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "member",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Club",
                                    "kind": "LinkedField",
                                    "name": "club",
                                    "plural": false,
                                    "selections": (v47/*: any*/),
                                    "storageKey": null
                                  },
                                  (v50/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "memberProfiles(active:true,hidden:false)"
                  },
                  {
                    "alias": "memberUserProfiles",
                    "args": (v51/*: any*/),
                    "concreteType": "MemberProfileConnection",
                    "kind": "LinkedField",
                    "name": "memberProfiles",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberProfileEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberProfile",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Club",
                                "kind": "LinkedField",
                                "name": "club",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v14/*: any*/),
                                  (v13/*: any*/),
                                  (v16/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "memberProfiles(active:true,hidden:false)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "expoTokens",
                        "storageKey": null
                      },
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": (v12/*: any*/),
                    "concreteType": "MemberProfileConnection",
                    "kind": "LinkedField",
                    "name": "memberProfiles",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberProfileEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberProfile",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "member",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v17/*: any*/),
                                  (v50/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "memberProfiles(active:true)"
                  }
                ],
                "type": "MemberUser",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "masquerader",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v7/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v33/*: any*/),
        "concreteType": "UnauthenticatedClub",
        "kind": "LinkedField",
        "name": "unauthenticatedClub",
        "plural": false,
        "selections": [
          (v31/*: any*/),
          (v6/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v30/*: any*/),
          (v32/*: any*/),
          (v34/*: any*/),
          (v46/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dd96d84ee8cabb905bae582ddf13aa00",
    "id": null,
    "metadata": {},
    "name": "ClubNavigatorQuery",
    "operationKind": "query",
    "text": "query ClubNavigatorQuery(\n  $clubSlug: String!\n) {\n  session {\n    ...ClubStackNavigatorFragment_session\n    ...useSyncAnalyticsTrackingPermission_session\n    user {\n      __typename\n      ...useRegisterDeviceForPushNotificationsAsyncFragment_memberUser\n      id\n      email\n      username\n      ... on MemberUser {\n        preferredLocale\n        metadata {\n          hasSeenNotificationNudgeModal\n        }\n        memberProfiles(active: true) {\n          edges {\n            node {\n              id\n              member {\n                __typename\n                club {\n                  id\n                  name\n                  slug\n                  logoImage {\n                    publicId: renderingKey\n                  }\n                }\n                ... on Node {\n                  __isNode: __typename\n                  id\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    currentClientProfile {\n      __typename\n      member {\n        __typename\n        ... on Member {\n          id\n          firstName\n          lastName\n          email\n          phoneNumber {\n            nationalNumber\n            id\n          }\n          membershipType {\n            id\n          }\n          profileImage {\n            publicId: renderingKey\n          }\n          memberGroups {\n            id\n          }\n          departmentMemberProfiles(type: GOLF) {\n            __typename\n            ... on GolfMemberProfile {\n              ghinNumber\n              department {\n                slug\n                id\n              }\n            }\n            id\n          }\n        }\n        ... on Customer {\n          departmentMemberProfiles(type: GOLF) {\n            __typename\n            ... on GolfMemberProfile {\n              ghinNumber\n              department {\n                slug\n                id\n              }\n            }\n            id\n          }\n          id\n          email\n          phoneNumber {\n            nationalNumber\n            id\n          }\n          firstName\n          lastName\n          profileImage {\n            publicId: renderingKey\n          }\n          membershipType {\n            id\n          }\n        }\n        club {\n          id\n          name\n          slug\n          supportsPublic\n          defaultLocale\n          logoImage {\n            publicId: renderingKey\n          }\n          appCustomization {\n            conversionAnalytics {\n              enabled\n              gtmContainerId\n              ga4MeasurementId\n              metaPixelId\n            }\n            id\n          }\n          ...ClubCurrencyContextFragment\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  unauthenticatedClub(slug: $clubSlug) {\n    defaultLocale\n    id\n    name\n    slug\n    supportsPublic\n    conversionAnalytics {\n      enabled\n      gtmContainerId\n      ga4MeasurementId\n      metaPixelId\n    }\n    logoImage {\n      publicId: renderingKey\n    }\n    ...ClubCurrencyContextUnauthenticatedFragment\n  }\n}\n\nfragment BookButton_session on Session {\n  ...BookModal_session\n}\n\nfragment BookModal_session on Session {\n  ...BookNow_session\n}\n\nfragment BookNow_session on Session {\n  ...ScheduleSwitcher_session\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      club {\n        ...useGetClubStartOfWeekNumberPatron_club\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment ClubCurrencyContextFragment on Club {\n  currency\n}\n\nfragment ClubCurrencyContextUnauthenticatedFragment on UnauthenticatedClub {\n  currency\n}\n\nfragment ClubStackNavigatorFragment_session on Session {\n  ...ClubSwitcherFragment_session\n  ...HomeTabsNavigator_session\n  ...LessonFacilitySwitcherModalFragment_session\n  ...MasqueradeBarPatronFragment_session\n  ...useCurrentClubHasLessonsEnabled_session\n  user {\n    id\n    email\n    __typename\n    ... on MemberUser {\n      ...ClubSwitcherFragment_memberUser\n    }\n  }\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      clientClass\n      club {\n        slug\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on MemberProfile {\n      id\n      onboardedAt\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment ClubSwitcherFragment_memberUser on MemberUser {\n  memberUserProfiles: memberProfiles(active: true, hidden: false) {\n    edges {\n      node {\n        club {\n          id\n          slug\n          name\n          logoImage {\n            publicId: renderingKey\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment ClubSwitcherFragment_session on Session {\n  staffAccessAvailable\n}\n\nfragment HomeScreen_session on Session {\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      ... on Member {\n        id\n      }\n      ... on Customer {\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment HomeTabsNavigator_session on Session {\n  ...TabBarNav_session\n  ...HomeScreen_session\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      club {\n        departments {\n          edges {\n            node {\n              anyFacilityEventsEnabled\n              id\n            }\n          }\n        }\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment LessonFacilitySwitcherModalFragment_session on Session {\n  ...useIsCurrentUserPublic_session\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      club {\n        copyOverrides {\n          lesson {\n            singular\n          }\n        }\n        facilities {\n          edges {\n            node {\n              name\n              slug\n              isLessonsEnabled\n              privateLessonsPermissionSet {\n                patronAccess\n                id\n              }\n              publicLessonsPermissionSet {\n                patronAccess\n                id\n              }\n              department {\n                type\n                id\n              }\n              id\n            }\n          }\n        }\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment MasqueradeBarPatronFragment_session on Session {\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      ... on Member {\n        email\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  masquerader {\n    __typename\n    email\n    id\n  }\n}\n\nfragment ScheduleSwitcher_session on Session {\n  ...useGetScheduleSwitcherOptionsFragment_session\n}\n\nfragment TabBarNav_session on Session {\n  ...useGetTabBarItemsFragment_session\n  ...BookButton_session\n}\n\nfragment departmentToScheduleOption_department on Department {\n  type\n  id\n  slug\n  name\n}\n\nfragment facilityToScheduleOption_facility on Facility {\n  id\n  slug\n  name\n  type\n  department {\n    type\n    id\n  }\n}\n\nfragment getFacilityMemberPermissions_facility on Facility {\n  club {\n    id\n    supportsPrivate\n    supportsPublic\n  }\n  publicBookingPermissionSet {\n    id\n    isFacilityVisible\n    isFacilityBookable\n    areOtherBookingsVisible\n    areOtherBookingsJoinable\n    canBookOnBusySlot\n  }\n  privateBookingPermissionSet {\n    id\n    isFacilityVisible\n    isFacilityBookable\n    areOtherBookingsVisible\n    areOtherBookingsJoinable\n    canBookOnBusySlot\n  }\n}\n\nfragment useCurrentClubHasLessonsEnabled_session on Session {\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      club {\n        supportsPublic\n        facilities {\n          edges {\n            node {\n              publicLessonsPermissionSet {\n                patronAccess\n                id\n              }\n              privateLessonsPermissionSet {\n                patronAccess\n                id\n              }\n              id\n            }\n          }\n        }\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useCurrentClubHasVisibleLessons_session on Session {\n  ...useIsCurrentUserPublic_session\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      club {\n        departments {\n          edges {\n            node {\n              anyFacilityLessonsEnabled\n              facilities {\n                edges {\n                  node {\n                    isLessonsEnabled\n                    publicLessonsPermissionSet {\n                      patronAccess\n                      id\n                    }\n                    privateLessonsPermissionSet {\n                      patronAccess\n                      id\n                    }\n                    id\n                  }\n                }\n              }\n              id\n            }\n          }\n        }\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useGetClubStartOfWeekNumberPatron_club on Club {\n  calendarStartDay\n}\n\nfragment useGetScheduleSwitcherOptionsFragment_session on Session {\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      club {\n        facilities {\n          edges {\n            node {\n              type\n              id\n              ...getFacilityMemberPermissions_facility\n              ...facilityToScheduleOption_facility\n              department {\n                id\n                type\n                ...departmentToScheduleOption_department\n              }\n            }\n          }\n        }\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useGetTabBarItemsFragment_session on Session {\n  staffAccessAvailable\n  ...useGoToStore_session\n  ...useCurrentClubHasVisibleLessons_session\n  ...useLessonTabHandler_session\n  user {\n    __typename\n    ... on MemberUser {\n      activeMemberProfiles: memberProfiles(active: true, hidden: false) {\n        count\n        edges {\n          node {\n            hidden\n            member {\n              __typename\n              club {\n                slug\n                id\n              }\n              ... on Node {\n                __isNode: __typename\n                id\n              }\n            }\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  currentClientProfile {\n    __typename\n    ... on MemberProfile {\n      id\n    }\n    member {\n      __typename\n      club {\n        ...useIsClubSellingStandardPackages_club\n        ...useIsClubSellingMemberships_club\n        supportsPublic\n        supportsPrivate\n        slug\n        copyOverrides {\n          event {\n            plural\n          }\n          lesson {\n            plural\n          }\n        }\n        appCustomization {\n          externalLinks {\n            displayName\n            url\n          }\n          id\n        }\n        departments {\n          edges {\n            node {\n              anyFacilityEventsEnabled\n              anyFacilityLessonsEnabled\n              id\n            }\n          }\n        }\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useGoToStore_session on Session {\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      ... on Customer {\n        club {\n          ...useIsClubSellingStandardPackages_club\n          ...useIsClubSellingMemberships_club\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useIsClubSellingMemberships_club on Club {\n  memberships: packages(packageType: MEMBERSHIP, saleAvailability: PUBLIC) {\n    count\n  }\n}\n\nfragment useIsClubSellingStandardPackages_club on Club {\n  standardPackages: packages(packageType: STANDARD, saleAvailability: PUBLIC) {\n    count\n  }\n}\n\nfragment useIsCurrentUserPublic_session on Session {\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      clientClass\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useLessonTabHandler_session on Session {\n  ...useIsCurrentUserPublic_session\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      club {\n        facilities {\n          edges {\n            node {\n              slug\n              isLessonsEnabled\n              publicLessonsPermissionSet {\n                patronAccess\n                id\n              }\n              privateLessonsPermissionSet {\n                patronAccess\n                id\n              }\n              id\n            }\n          }\n        }\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useRegisterDeviceForPushNotificationsAsyncFragment_memberUser on MemberUser {\n  id\n  metadata {\n    expoTokens\n  }\n}\n\nfragment useSyncAnalyticsTrackingPermission_session on Session {\n  allowUnauthenticatedAnalyticsTracking\n  requiresAnalyticsTrackingConsent\n  user {\n    __typename\n    ... on MemberUser {\n      metadata {\n        analyticsTrackingConsentedAt\n      }\n    }\n    id\n  }\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      club {\n        defaultCountryCode\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "13ab8521deb790fa3f60417592d40d7b";

export default node;
